/**
 * Component that displays the lineup for a game
 */
import React from "react";
import { useParams } from "react-router-dom";
import { useQuery } from "@tanstack/react-query";
import ProfileImageContainer from "../core/ProfileImageContainer.js";
import Loading from "../core/Loading.js";
import { Link } from "react-router-dom";

const processLineupData = (jsonData, game_data) => {
  let processedData = {
    team_name: jsonData.team_name,
    lineup: jsonData.lineup,
    club: jsonData.club,
    team_img: jsonData.team_img,
  };

  return processedData;
};

const GameLineup = (game_data) => {
  const { gameId } = useParams();

  const { isLoading, error, data } = useQuery({
    staleTime: 3600000,
    queryKey: ["game", gameId, "lineup", game_data.team],
    queryFn: () =>
      fetch(
        `${process.env.REACT_APP_BUIHA_API_URL}/game/${gameId}/lineup/${game_data.team}/`
      )
        .then((res) => res.json())
        .then((json) => {
          return processLineupData(json, game_data);
        }),
  });

  if (isLoading) return <Loading />;

  if (error) return "An error has occurred: " + error.message;

  return (
    <div className="flex-row items-left justify-left w-full xs:mx-2">
      <p className="my-2 leading-tight text-center">
        {data.team_name}
      </p>
      <div className="dark:bg-dark-4 bg-light-2 rounded p-1 pb-2 w-full mb-2">
      {data.lineup.length > 0 ? (
        <table className="table-auto w-full">
          <thead>
            <tr>
              <th colSpan={2} className="text-center pb-1 lg:b-2 font-normal">
                Players
              </th>
            </tr>
          </thead>
          <tbody>
            {data.lineup.map((player, index) => (
              <tr
                key={index}
                className={
                  index % 2 === 0
                    ? "bg-light-1 dark:bg-dark-1"
                    : "bg-light-2 dark:bg-dark-4"
                }
              >
                <td>
                  <div className="w-20 h-20 my-1 p-1 ml-2">
                    <ProfileImageContainer
                      player={player.player_id}
                      club={data.club}
                      backup={data.team_img}
                      alt={player.player_name}
                      extraClasses={"rounded"}
                    />
                  </div>
                </td>
                <td className="w-full pt-1 text-center">
                    <Link to={`/player/${player.player_id}`}>
                    <p className="hover:text-buiha-red dark:hover:text-dark-5 ease-in-out duration-200 font-normal">
                      {player.player_name}</p>
                    </Link>
                  <p className="px-2 max-xs:text-xs text-smm font-light">{player.institution}</p>
                  <span className="px-2 max-xs:text-xxs text-smm font-light text-darken">
                    GP: {player.games}
                  </span>
                  <span className="px-2 max-xs:text-xxs text-smm font-light text-darken">
                    G: {player.goals}
                  </span>
                  <span className="px-2 max-xs:text-xxs text-smm font-light text-darken">
                    A: {player.assists}
                  </span>
                  <span className="px-2 max-xs:text-xxs text-smm font-light text-darken">
                    PIMs: {player.pims}
                  </span>
                  <span className="px-2 max-xs:text-xxs text-smm font-light text-darken">
                    Pts: {player.points}
                  </span>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
        ) : (
          <p className="text-center pt-1 text-darken font-light">No players available</p>
        )}
      </div>
    </div>
  );
};
export default GameLineup;
